import { APP } from "./app"
import { ENUM } from "./enum"
import { FORMAT } from "./format"
import { ICON } from "./icon"
import { MENU } from "./menu"
import { MESSAGE } from "./message"
import { REGEXP } from "./regexp"
import { SEO } from "./seo"

export const CONSTANT = { APP, ENUM, FORMAT, ICON, MENU, MESSAGE, REGEXP, SEO }
